<ion-footer class="prestataire-footer" [ngStyle]="{ 'display': isKeyboardVisible ? 'none' : 'block' }" [ngClass]="{ 'keyboard-visible': isKeyboardVisible }">
  <ion-toolbar class="prestataire-footer__toolbar">
    <ion-buttons class="prestataire-footer__buttons">
      <ion-button class="toolbar-button accords" [ngClass]="{ active: activatedRouteIndex === 1 }" (click)="prestataireDemands()">
        <span class="tab-content">
          <ion-icon [name]="activatedRouteIndex === 1 ? 'document-text' : 'document-text-outline'"></ion-icon>
          <span class="tab-label">{{ "PROVIDER.FOOTER.MY_ACCORDS" | translate }}</span>
        </span>
      </ion-button>
      <ion-button class="toolbar-button home" [ngClass]="{ active: activatedRouteIndex === 0 }" (click)="goTo('')">
        <span class="tab-content">
          <ion-icon [name]="activatedRouteIndex === 0 ? 'home' : 'home-outline'"></ion-icon>
          <span class="tab-label">{{ "PROVIDER.FOOTER.HOME" | translate }}</span>
        </span>
      </ion-button>
      <ion-button class="toolbar-button profile" [ngClass]="{ active: activatedRouteIndex === 2 }" (click)="goTo('menu')">
        <span class="tab-content">
          <ion-icon [name]="activatedRouteIndex === 2 ? 'person' : 'person-outline'"></ion-icon>
          <span class="tab-label">{{ "PROVIDER.FOOTER.MY_DEMANDS" | translate }}</span>
        </span>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>

<ion-modal [initialBreakpoint]="1" [isOpen]="confirmDemandModal.length" [backdropDismiss]="false">
  <ng-template>
    <div class="confirm-meeting-modal">
      <app-meeting-conformation-modal [status]="meeetingStatus"
        [id]="confirmDemandModal.length ? confirmDemandModal[0].demande_id.id : null"></app-meeting-conformation-modal>
    </div>
  </ng-template>
</ion-modal>

<ion-modal [isOpen]="false" [breakpoints]="[0, 1]">
  <ng-template>
    <div class="first-demand-modal">
      <app-first-demand></app-first-demand>
    </div>
  </ng-template>
</ion-modal>

<ion-modal [isOpen]="false" [breakpoints]="[0, 1]">
  <ng-template>
    <div class="sent-demand-modal">
      <app-demande-sent></app-demande-sent>
    </div>
  </ng-template>
</ion-modal>

<ion-modal [initialBreakpoint]="1" [isOpen]="bankLinkModal" [backdropDismiss]="false">
  <ng-template>
    <div class="bank-link-modal">
      <app-bank-link></app-bank-link>
    </div>
  </ng-template>
</ion-modal>

<ion-modal [initialBreakpoint]="1" [isOpen]="backgroundLocationAlwaysModal" [backdropDismiss]="false">
  <ng-template>
    <div class="background-location-always-modal">
      <app-background-location-always></app-background-location-always>
    </div>
  </ng-template>
</ion-modal>
